export default __webpack_public_path__ + "static/shape-c108a18a1d62bfcf7d9a12855e86cdec.png";